import React, { useState, useEffect, useRef } from "react";
import CreatableSelect from "react-select/creatable";
import { store } from "../../redux/store";
import * as constantAction from "../../redux/actions/constantActions";
import { useSelector } from "react-redux";
import { Tooltip, Typography, Box, useTheme, useMediaQuery } from "@mui/material";

export default function DiseaseSelectorWithCreatable({
  labelKey,
  valueKey,
  data = [],
  savedData = [],
  onChange = () => { },
  edit = true,
}) {
  const [selected, setSelected] = useState(savedData);
  const [maxVisible, setMaxVisible] = useState(0);
  const containerRef = useRef(null);
  const [customDiseases, setCustomDiseases] = useState([]);
  const [customAllergy, setCustomAllergy] = useState([]);
  const constantReducer = useSelector(state => state.constantReducer)


const theme = useTheme();
const isMd = useMediaQuery(theme.breakpoints.down('md'));
const isLg = useMediaQuery(theme.breakpoints.down('lg'));

const fontSize = isMd ? '10px' : isLg ? '11px' : '12px';

  useEffect(() => {
    setSelected(savedData);
  }, [savedData]);

  useEffect(() => {
    if (containerRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      const chipWidth = 100;
      const chipsPerLine = Math.floor(containerWidth / chipWidth);
      setMaxVisible(chipsPerLine * 2 - 1);
    }
  }, []);

  const selectedIds = selected.map((item) => item[valueKey]);

  const notifyChange = (newSelected) => {
    setSelected(newSelected);
    onChange(newSelected, labelKey);
  };

  const handleChipClick = (disease) => {
    const isSelected = selectedIds.includes(disease.id);
    let newSelected;

    if (isSelected) {
      newSelected = selected.filter((item) => item[valueKey] !== disease.id);
    } else {
      newSelected = [
        {
          [valueKey]: disease.id,
          [labelKey]: disease.name
        },
        ...selected,
      ];
    }

    notifyChange(newSelected);
  };

  const handleSelect = (newValue) => {
    if (!newValue) return;

    const diseaseExists = data.find((d) => d.id === newValue.value);
    const isAlreadySelected = selectedIds.includes(newValue.value);

    if (!isAlreadySelected && diseaseExists) {
      notifyChange([
        { [valueKey]: diseaseExists.id, [labelKey]: diseaseExists.name },
        ...selected,
      ]);
    }
  };

  useEffect(() => {
    const constant = constantReducer?.constantCreated;
    if (constant?.id) {
      if (constantReducer.label === valueKey) {
      if (constantReducer.label == "diseaseId") {
        setCustomDiseases(prev => [
          ...prev,
          { name: constant.name, id: constant.id }
        ]);
      }
      else if (constantReducer.label == "allergyId") {
        setCustomAllergy(prev => [
          ...prev,
          { name: constant.name, id: constant.id }
        ]);
      }


      notifyChange([
        { [labelKey]: constant.name, [valueKey]: constant.id },
        ...selected
      ]);
  
      if (constant?.id) {
        store.dispatch(constantAction.resetConstantState());
      }
    }
    }
  }, [constantReducer?.constantCreated]);

  const handleCreate = (inputValue) => {
    if (!inputValue) return;
    if (!selectedIds.includes(inputValue)) {
      store.dispatch(constantAction.createConstantRequestAction(inputValue, valueKey))
    }
  };

  const allDiseases =
    labelKey === "diseaseName"
      ? [...data, ...customDiseases]
      : [...data, ...customAllergy];

  const selectedItems = selected
    .map((item) => allDiseases.find((d) => d.id === item[valueKey]))
    .filter(Boolean);

  const displayItems =
    !edit && selected.length > 0
      ? selectedItems
      : [
        ...selectedItems,
        ...data.filter((d) => !selectedIds.includes(d.id)),
      ].slice(0, maxVisible);

  const dropdownItems =
    !edit && selected.length > 0
      ? []
      : [
        ...selectedItems,
        ...data.filter((d) => !selectedIds.includes(d.id)),
      ].slice(maxVisible);

  const dropdownOptions = dropdownItems.map((item) => ({
    label: item.name,
    value: item.id,
  }));
  return (
    <div
      ref={containerRef}
      style={{
        display: "flex",
        flexWrap: "wrap",
        rowGap: "6px",
        columnGap: "6px",
        padding: "6px",
        // maxHeight: "60px",
        overflow: "hidden",
        alignContent: "flex-start",
        alignItems: "flex-start",
        width: '100%',
        position: "relative"
      }}
    >
      {
        (!edit && selected.length == 0) ?
          <div
            ref={containerRef}
            style={{
              padding: "6px",
              height: "60px",
            }}
          >
            <Typography sx={{ fontSize: {xl:'14px', lg:'13px', md:'12px'}, color: "#333", }}>
              No record..
            </Typography>
          </div>
          :
          displayItems.map((disease) => {
            const isSelected = selectedIds.includes(disease.id);
            return (
              <Tooltip title={disease.name}>
                <Box
                  key={disease.id}
                  onClick={() => edit && handleChipClick(disease)}
                  sx={{
                    p: 0.6,
                    // py: '4px',
                    borderRadius: 2,
                    cursor: edit ? 'pointer' : 'default',
                    border: isSelected ? '1px solid #919191' : 'none',
                    // color: isSelected ? 'black' : '#333',
                    whiteSpace: 'nowrap',
                    lineHeight: '18px',
                    maxHeight: '26px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '100px',
                    display: 'inline-block',
                    
                  }}
                >
                  <Typography sx={{fontSize: { xl: '14px', lg: '12px', md: '11px' },}}>
                  {disease.name}
                  </Typography>
                </Box>
              </Tooltip>
            );
          })
      }
      {edit && (
        <div style={{ flexShrink: 0, minWidth: "120px" }}>
          <CreatableSelect
            placeholder="+ Add"
            options={dropdownOptions}
            onChange={handleSelect}
            onCreateOption={handleCreate}
            menuPortalTarget={document.body}
            styles={{
              container: (base) => ({
                ...base, minWidth: "120px", height: "26px",
                flexShrink: 0,fontSize,
              }),
              control: (base) => ({ ...base, height: "26px", minHeight: "26px", border: 'none', borderRadius: '10px', boxShadow: "none",fontSize,backgroundColor:'#F2F2F2' }),
              valueContainer: (base) => ({ ...base, padding: "0 6px",fontSize, }),
              indicatorsContainer: (base) => ({ ...base, height: "26px",fontSize, }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected
                  ? "grey"
                  : state.isFocused
                  ? "#D3D3D3"
                  : "transparent",
                color: state.isSelected ? "#fff" : "black",
                cursor: "pointer",
              }),
            }}
          />
        </div>
      )}
    </div>
  );
}
